import { render, staticRenderFns } from "./choose.vue?vue&type=template&id=90cac2f4&scoped=true&"
import script from "./choose.vue?vue&type=script&lang=js&"
export * from "./choose.vue?vue&type=script&lang=js&"
import style0 from "./choose.vue?vue&type=style&index=0&id=90cac2f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90cac2f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90cac2f4')) {
      api.createRecord('90cac2f4', component.options)
    } else {
      api.reload('90cac2f4', component.options)
    }
    module.hot.accept("./choose.vue?vue&type=template&id=90cac2f4&scoped=true&", function () {
      api.rerender('90cac2f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customPage/choose.vue"
export default component.exports